import { render, staticRenderFns } from "./SelectUserTagsModal.vue?vue&type=template&id=6f92396e&"
import script from "./SelectUserTagsModal.vue?vue&type=script&lang=ts&"
export * from "./SelectUserTagsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports